import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { BasicForm } from "@components/shared";

export default function AdminForm({
  id = null,
  email = "",
  firstName = "",
  lastName = "",
  mfa = false,
  onSuccess = () => {},
}) {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();
  function onSubmit(formData) {
    setLoading(true);

    if (id) return onUpdate(formData);

    return onCreate(formData);
  }

  function onCreate(formData) {
    axios
      .post(`/admins/`, { ...formData })
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:created") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  function onUpdate(formData) {
    const req = {
      ...formData,
      admin_id: id,
    };

    axios
      .put(`/admins/${id}/`, req)
      .then(() => setLoading(false))
      .then(() => toast.success(t("common:updated") + "!"))
      .then(() => onSuccess())
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  const fields = [
    {
      name: "first_name",
      label: t("common:first_name"),
      initialValue: firstName,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "last_name",
      label: t("common:last_name"),
      initialValue: lastName,
      required: true,
      schema: () =>
        Yup.string()
          .max(50, t("validation:too_long"))
          .required(t("validation:required")),
    },
    {
      name: "email",
      label: t("common:email"),
      initialValue: email,
      required: true,
      schema: () =>
        Yup.string()
          .max(100, t("validation:too_long"))
          .email(t("validation:email_invalid"))
          .required(t("validation:required")),
    },
    // {
    //   name: "mfa",
    //   label: "Multi-Factor Authentication",
    //   initialValue: mfa,
    //   required: false,
    //   schema: () => null,
    //   toggle: true,
    // },
  ];

  return (
    <BasicForm
      buttonProps={{
        fullWidth: !id ? true : false,
      }}
      loading={loading}
      onSubmit={onSubmit}
      fields={fields}
    />
  );
}
